import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Grid,
  Card,
  CardContent,
  CircularProgress,
  Backdrop,
  Button,
  Typography,
  useTheme,
  CardActions,
  Stack,
  Icon,
  IconButton,
  TextField,
  Autocomplete,
} from "@mui/material";
import { format as DateFormat } from "date-fns";
import { useSnackbar } from "notistack";
import { RemMensaje } from "../../redux/actions/mensajes";

import { useParams } from "react-router-dom";

import {
  getPoolVehiculos,
  getVehiculos,
  getVehiculoCargando,
  getVehiculoPropiedades,
  getVehiculoSeleccionado,
  getOpcionesPropiedades,
  getMensaje,
} from "../../redux/selectors";
import {
  ObtenerPoolVehiculos,
  ObtenerVehiculos,
  ObtenerPropiedades,
  SetMiMovil,
  SetCenso,
} from "../../redux/actions/vehiculo";
import ListaPropiedades from "./ListaPropiedades";
import Patentes from "./Patentes";

export const EstadoVehiculo = (props) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const paramsIng = useParams();
  const { enqueueSnackbar /*, closeSnackbar*/ } = useSnackbar();

  const backdrop = useSelector((state) => getVehiculoCargando(state));
  const mensaje = useSelector((state) => getMensaje(state));
  const poolMoviles = useSelector((state) => getPoolVehiculos(state));

  const moviles = useSelector((state) => getVehiculos(state));

  const movil = useSelector((state) => getVehiculoSeleccionado(state));
  const grupos = useSelector((state) => getVehiculoPropiedades(state));
  const opciones = useSelector((state) => getOpcionesPropiedades(state));

  const [respuestas, setRespuestas] = React.useState({});
  const [openMoviles, setOpenMoviles] = React.useState(false);
  const [mostrarError, setMostrarError] = React.useState(false);

  React.useEffect(() => {
    if (paramsIng.modo && paramsIng.modo === "1") {
      document.body.style.backgroundColor = "#2f3035";
    }
    dispatch(ObtenerVehiculos(paramsIng));
    dispatch(ObtenerPoolVehiculos(paramsIng));
  }, []);

  React.useEffect(() => {
    setRespuestas({});
    setMostrarError(false);
  }, [movil]);

  React.useEffect(() => {
    if (mensaje.mensaje !== "") {
      enqueueSnackbar(mensaje.mensaje, {
        preventDuplicate: true,
        anchorOrigin: { vertical: "bottom", horizontal: "center" },
        variant: mensaje.variant,
        autoHideDuration: 3000,
      });
      dispatch(RemMensaje());
    }
  }, [mensaje]);

  const ok = React.useMemo(
    () =>
      grupos.reduce(
        (a, v) =>
          a &&
          v.propiedades?.reduce(
            (a1, v1) =>
              a1 &&
              (Boolean(
                v1.tipo === 4 || v1.tipo === 5 || v1.tipo === 6
                  ? respuestas[v1.id]
                  : respuestas[v1.id]?.trim(),
              ) ||
                !v1.requerido),
            true,
          ),
        true,
      ),

    [grupos, respuestas],
  );
  React.useEffect(() => {
    const handleResize = () => {
      const elementoActivo = document.activeElement;

      if (elementoActivo) {
        // Un pequeño delay para dejar que la pantalla se reajuste
        setTimeout(() => {
          elementoActivo.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }, 150);
      }
    };

    // Escuchamos el cambio de tamaño del viewport visual (el teclado)
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", handleResize);
    } else {
      // Fallback para navegadores antiguos
      window.addEventListener("resize", handleResize);
    }

    // Limpieza al desmontar el componente para evitar fugas de memoria
    return () => {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", handleResize);
      } else {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);
  return (
    <>
      <Stack
        sx={{
          p: 1,
          overflow: "hidden",
          height: "100dvh",
        }}
      >
        <Backdrop
          sx={{
            zIndex: theme.zIndex.drawer + 1,
          }}
          open={backdrop}
        >
          <CircularProgress
            sx={{
              color: "#006699",
              m: "auto",
            }}
          />
        </Backdrop>
        <Card variant="outlined" sx={{ mb: 2 }}>
          <CardContent>
            <Stack direction="row" spacing={1} sx={{ mt: -1, mb: -1 }}>
              <Autocomplete
                options={moviles || []}
                noOptionsText="No tiene móviles vinculados"
                getOptionLabel={(option) => option.patente}
                value={movil}
                onChange={(event, newValue) => {
                  dispatch(
                    ObtenerPropiedades({
                      ...paramsIng,
                      movil: newValue,
                    }),
                  );
                }}
                renderInput={(params) => <TextField {...params} />}
              />

              <IconButton onClick={() => setOpenMoviles(true)}>
                <Icon>car_crash</Icon>
              </IconButton>
            </Stack>
          </CardContent>
        </Card>
        <Grid
          sx={{
            pb: 2,
            display: (backdrop && "none") || "inherits",
            overflowY: "auto",
            height: "calc(100vh - 112px)",
            alignItems: "stretch",
          }}
          container
          spacing={2}
        >
          {movil &&
            grupos &&
            grupos.length > 0 &&
            grupos.map(
              (g, index) =>
                g.propiedades &&
                g.propiedades.length > 0 && (
                  <Grid key={1001 + index} size={12}>
                    <Card
                      sx={{
                        height: "100%",
                        minHeight: "100px",
                        display: "flex",
                        flexDirection: "column",
                        backgroundColor: g.colorFondo,
                      }}
                      variant="outlined"
                    >
                      <CardContent>
                        <Stack spacing={1} sx={{ m: 0 }}>
                          {g.mostrarTitulo && (
                            <Typography
                              variant="body1"
                              color="primary"
                              sx={{ fontWeight: "bold", ml: -2 }}
                            >
                              {g.nombre}
                            </Typography>
                          )}

                          <ListaPropiedades
                            propiedades={g.propiedades}
                            opciones={opciones}
                            setRespuestas={setRespuestas}
                            respuestas={respuestas}
                            mostrarError={mostrarError}
                          />
                        </Stack>
                      </CardContent>
                    </Card>
                  </Grid>
                ),
            )}
        </Grid>
        {movil && grupos && (
          <Card variant="outlined">
            <CardActions sx={{ display: "flex", justifyContent: "center" }}>
              <Stack
                direction="column"
                spacing={0}
                sx={{ alignItems: "center" }}
              >
                {mostrarError && !ok && (
                  <Typography variant="caption" fontSize="" color="error">
                    Debe completar todos los campos requeridos.
                  </Typography>
                )}
                <Button
                  color={!ok ? "error" : "primary"}
                  onClick={(e) => {
                    if (!ok) {
                      e.preventDefault();
                      setMostrarError(true);

                      // setTimeout(() => {
                      //   const primerError = document.querySelector(
                      //     ,
                      //   );

                      //   if (primerError) {
                      //     primerError.scrollIntoView({
                      //       behavior: "smooth",
                      //       block: "center",
                      //     });
                      //     // primerError.focus();
                      //   }
                      // }, 100);

                      setTimeout(() => {
                        // Buscamos el INPUT real que esté dentro del contenedor con la clase de error de MUI
                        const inputConError = document.querySelector(
                          ".Mui-error input, " +
                            ".Mui-error textarea, " +
                            ".Mui-error button, " +
                            ".Mui-error [role='button'], " + // Por si MUI renderiza el botón con rol
                            "[data-invalid='true']", // Tu marcador personalizado
                        );

                        if (inputConError) {
                          // Hacemos el scroll suave
                          inputConError.scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                          });

                          // Le damos el foco al input real (esto levantará el teclado en móviles)
                          inputConError.focus();
                        }
                      }, 100);
                      return;
                    }

                    dispatch(
                      SetCenso({
                        token: paramsIng?.token || "",
                        guid: paramsIng?.guid || "",
                        id_movil: movil?.id_movil || 0,
                        respuestas: Object.entries(respuestas).map(
                          ([key, value]) => {
                            const tipo = grupos
                              .find(
                                (g) =>
                                  g.propiedades?.findIndex(
                                    (p) => p.id === Number(key),
                                  ) > -1,
                              )
                              ?.propiedades?.find(
                                (p) => p.id === Number(key),
                              )?.tipo;

                            return {
                              id: key,
                              respuesta:
                                tipo === 5
                                  ? DateFormat(value, "dd/MM/yyyy")
                                  : tipo === 4 || tipo === 6
                                    ? Number(value)
                                    : value?.trim()?.toString(),
                            };
                          },
                        ),
                      }),
                    );
                  }}
                >
                  Enviar
                </Button>
              </Stack>
            </CardActions>
          </Card>
        )}
      </Stack>
      <Patentes
        poolMoviles={poolMoviles || []}
        moviles={moviles}
        open={openMoviles}
        onClose={() => setOpenMoviles(false)}
        onSave={(v) => dispatch(SetMiMovil({ ...v, ...paramsIng }))}
      />
    </>
  );
};

export default EstadoVehiculo;
